/**
 * Normalisers applied at the wire boundary, so every screen sends the API the shape it documents
 * rather than each screen remembering to.
 */

/**
 * The bare ten-digit mobile the API expects, from however the number is currently held.
 *
 * Sign-in returns a DISPLAY-formatted number (`"+91 8107971780"` — the shape the customer auth
 * endpoints hand back) and that is what lands in the auth store, so the stored value cannot be
 * posted straight back. It answered "Enter a valid 10-digit mobile number" for the number the
 * customer had just signed in with, and no retry could succeed because the stored value never
 * changed. Taking the LAST ten digits also survives a leading `0`, a `+91`, or typed spaces.
 *
 * Taking the last ten (rather than just stripping non-digits) is the part that matters: a bare
 * strip leaves the country code on, so `"+91 8107971780"` becomes twelve digits and no longer
 * equals the same customer's number sent from a screen that did strip it properly.
 */
export function wirePhone(phone: string | null | undefined): string {
  return (phone ?? '').replace(/\D/g, '').slice(-10);
}
